export default __webpack_public_path__ + "static/banner-how-rewards-credit-cards-are-devaluing-edcb7a286ea2ed8dbe75a2e771ba970a.jpg";